import { useTranslations } from 'next-intl';
import React from 'react';
import useOfferComparisonStore from '../store/use-offer-comparison-store';

export default function PriceInfoFinePrint({
  isGerman,
}: {
  isGerman: boolean;
}) {
  const t = useTranslations('priceInfo');
  const discounts =
    useOfferComparisonStore((state) => state.offer?.netCosts.energyDiscounts) ??
    0;
  const hasDiscounts = discounts > 0;
  return (
    <div className="pt-4 pb-8 md:pb-[132px] flex flex-col">
      {hasDiscounts && (
        <p data-testid="cost-info-finePrintBonus" className="pb-4">
          <sup>1</sup>&nbsp;{t('footnoteBonus')}
        </p>
      )}
      {!isGerman && (
        <p data-testid="cost-info-finePrintGridCosts">
          <sup>{hasDiscounts ? 2 : 1}</sup>&nbsp;
          {t('footnoteGridCosts')}
        </p>
      )}
    </div>
  );
}
